<template>
  <span>
    <div v-if="showBookmark"
         class="bookmark"
         :class="{'bookmark-isef' : $isIsef}">
      <span v-if="!canView"
            class="icon"
            :data-balloon="showBalloon('Bookmark', hasSubscribed)"
            data-balloon-pos="down-right" @click.stop.prevent="canSubscribe">
        <i  :class="{
              subcribed: !hasSubscribed,
              'fa-bookmark fa' : !$isIsef || hasSubscribed,
              'fa-regular fa-bookmark': $isIsef && !hasSubscribed,
              'bookmark-icon' : !$isIsef
            }"
           aria-label="Click to bookmark project"
           tabindex="0" @keypress.enter.space="canSubscribe" />
      </span>
      <span v-else>
        <i class="fa-lock fa-solid"/>
      </span>
    </div>
    <div v-if="this.$isYSC"
         class="location">
      <span class="location_container" :class="{'location_region': isRegion}">
        <img class="location_image"
             :class="{'location_image-phone': isPhone && isHome}"
             :src="location.flag"
             :alt="location.province" />
      </span>
      <div class="is-flex">
        <span>
            {{ location.province }}
        </span>
        <span>•</span>
        <span class="location_year">
          {{ getYear }}
        </span>
      </div>
    </div>
  </span>
</template>

<script>
import auth from '@/mixins/auth'
import subscribe from '@/mixins/subscribe'
export default {
  props: {
    project: Object
  },
  mixins: [auth, subscribe],
  computed: {
    isPhone: function () {
      return (/Android|iPhone/i.test(navigator.userAgent))
    },
    isHome: function () {
      return this.$route.fullPath.includes('/home')
    },
    isRegion: function () {
      return this.$route.fullPath.includes('/region')
    },
    getYear: function () {
      return new Date(this.project.created).getFullYear()
    },
    canView: function () {
      return this.project?.isLocked && !this.isLoggedIn && this.$isStories
    },
    showBookmark: function () {
      if (this.$route.name === 'search' && this.$isIsef) return false
      if (this.$isYSC) return false
      switch (this.$route.path) {
        case '/profile':
          return false
        case '/mine':
          return false
        default:
          return true
      }
    },
    location: function () {
      const regionDetails = this.project.regionProject?.regionDetails
      const provinceDetails = this.project.regionProject?.regionDetails?.provinceDetails

      if (provinceDetails?.abbr !== 'IN') {
        return {
          province: provinceDetails.abbr.toLowerCase(),
          flag: provinceDetails.flag
        }
      } else {
        return {
          province: provinceDetails.abbr.toLowerCase(),
          flag: regionDetails.flag
        }
      }
    }
  },
  methods: {
    showBalloon: function (action, success) {
      if (success) {
        if (this.$isHeise) {
          action = 'Gemerkt'
        } else {
          action = 'Bookmarked'
        }
      }
      if (!this.isMobile) {
        if (this.$isHeise) {
          switch (this.project.type && this.project) {
            case 'discussion':
              return success ? action : this.$t('story-header.bookmark.project')
            case 'project':
              return success ? action : this.$t('story-header.bookmark.project')
            default:
              return success ? action : this.$t('story-header.bookmark.project')
          }
        }
        return success ? action : `${action} this ${this.project?.type}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.location {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: .6em;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
  font-weight: 400;
  font-family: $primary-font;
  @include touch {
    font-size: 0.5em;
  }
  &_container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  &_region {
    @include mobile {
      margin-top: .7rem;
    }
  }
  &_image {
    width: auto;
    height: 22px;
    @include touch {
      height: 15px;
    }
  }
  @include mobile {
    margin-top: 3px;
  }
}
.bookmark {
  position: absolute;
  z-index: 5;
  right: 1.5%;
  color: $primary;
  &-isef {
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 10px;
    right: 10px !important;
    width: 32px;
    height: 32px;
    background-color: #DDDDDD;
  }
  &-icon {
    font-size: 1.4rem;
    @include mobile {
      font-size: 1.1rem;
    }
  }
  .subcribed {
    color: var(--background-third);
  }
  bottom: 90%;
  @include tablet-only {
    bottom: 87.8%;
  }
  @include mobile {
    bottom: 89%;
  }
}
</style>
